import type { IRecentMenuUpdater } from '@core/interfaces/IRecentMenuUpdater';

export default {
  update() {},
} as IRecentMenuUpdater;
